import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';

// Idea from : http://jasonwatmore.com/post/2016/09/29/angular-2-user-registration-and-login-example-tutorial

@Injectable()
export class AlertService {
 
  private subject = new Subject<any>();

  constructor() {
  }

  success(message: string) {
    this.subject.next({type: 'success', text: message});
  }

  error(message: string) {
    this.subject.next({type: 'error', text: message});
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/core/alert/alert.service.ts